import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-right-pipe', 'ChevronRightPipe', [["path",{"d":"M6 6l6 6l-6 6"}],["path",{"d":"M17 5v13"}]]);